import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['list', 'error']

  declare readonly listTarget: HTMLElement
  declare readonly errorTargets: HTMLElement[]

  global (): void {
    this.listTarget.classList.add('hidden')
    this.errorTargets.forEach(error => error.classList.add('hidden'))
    this.destroyInputs().forEach(input => {
      input.dataset.previousValue = input.value
      input.value = 'true'
    })
  }

  specific (): void {
    this.listTarget.classList.remove('hidden')
    this.errorTargets.forEach(error => error.classList.remove('hidden'))
    this.destroyInputs().forEach(input => {
      input.value = input.dataset.previousValue ?? input.value
      delete input.dataset.previousValue
      if (input.value === 'false') input.closest('[data-controller~="removable"]')?.classList.remove('hidden')
    })
    document.dispatchEvent(new Event('statusChanged'))
    if (this.rows().every(row => row.classList.contains('hidden'))) this.dispatch('empty', { detail: {} })
  }

  private rows (): HTMLElement[] {
    return Array.from(this.listTarget.querySelectorAll<HTMLElement>('[data-controller~="removable"]'))
  }

  private destroyInputs (): HTMLInputElement[] {
    return Array.from(this.listTarget.querySelectorAll<HTMLInputElement>('[data-removable-target="destroyInput"]'))
  }
}
